import { CustomerReportsTypes as Type } from '../../../types/customerreport';

const initialState = {
  customerReportList: [],
  loading: false,
  error: null,
};

const CustomerReportListReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case Type.GET_CUSTOMER_REPORT_LIST_REQUEST:
      return { ...state, loading: true, error: null, customerReportList: [] };
    case Type.GET_CUSTOMER_REPORT_LIST_REQUEST_SUCCESS:
      return {
        ...state,
        customerReportList: action.payload,
        loading: false,
      };
    case Type.GET_CUSTOMER_REPORT_LIST_REQUEST_FAILURE:
      return { ...state, error: action.error, loading: false };
    default:
      return state;
  }
};

export default CustomerReportListReducer;